var render = function render(){var _vm=this,_c=_vm._self._c;return _c('collage',{attrs:{"primary-item":_vm.content.items[2],"secondary-items":_vm.secondaryItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }